const contract_state = {}
const modal_state = {
  privateKey: false
}
export default {
  contracts: contract_state,
  modal: modal_state,
  accounts: '',
  notification: {
    isVisible: false,
    body: ''
  }
}
